import { useState } from 'react';
import Header from 'Header';
import Wishlist from 'Wishlist';
import RecentlyViewed from 'RecentlyViewed';

const Body = () => {
    const [section, switchSection] = useState(0)
    const [isAuthenticated, setIsAuthenticated] = useState(true);

    const hideOverlay = () => {
        const overlay = document.getElementById('wishlist-overlay');
        if (overlay) {
            overlay.classList.remove('show');
            document.body.classList.remove('no-scroll');
        }
        const mobileWishlistBtn = document.getElementById('mobileWishlistBtn');
        mobileWishlistBtn.classList.remove('active');
    };

    const showNotification = (message) => {
        const notificationHtml = `
            <div class="notification">
                <img src="https://cdn.curtainsmadesimple.co.uk/Images-New/Common/Tick-Grey.webp" alt="success" class="max-width-18"> ${message}
            </div>`;

        const notificationContainer = document.getElementById('notification');
        if (notificationContainer) {
            notificationContainer.insertAdjacentHTML('beforeend', notificationHtml);

            setTimeout(() => {
                notificationContainer.innerHTML = '';
            }, 3000);
        }

        const notificationContainerMobile = document.getElementById('mobile-notification-container');
        if (notificationContainerMobile) {
            notificationContainerMobile.insertAdjacentHTML('beforeend', notificationHtml);

            setTimeout(() => {
                notificationContainerMobile.innerHTML = '';
            }, 3000);
        }
    };

    const handleBackgroundClick = (e) => {
        if (e.target.classList.contains('wishlist-overlay')) {
            hideOverlay();
        }
    };

    return (
        <div className='hide mobile-menu' id="wishlist-overlay" onClick={handleBackgroundClick}>
            <div className="overlay-with-box headings-overlay active-group wishlist-overlay">
                <div className="overlay-box active-group flex-column pb-70 fit-content mobile-menu-container sm-px-12 react-overlay sm-pt-128">
                    <div className='width-600 sm-max-w-100'>
                        <Header switchSection={switchSection} hideOverlay={hideOverlay} />

                        {!isAuthenticated && (
                            <div className="max-width-310 body-text3 dark-text mt-16">
                                Wishlist is not saved permanently yet. <br />
                                Please <a className="underline" href="/login">Log in</a> or{' '}
                                <a className="underline" href="/sign-up">Create Account</a> to save it.
                            </div>
                        )}
                        
                        {section === 0 ? <Wishlist showNotification={showNotification} /> : <RecentlyViewed showNotification={showNotification} /> }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Body;